/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import Close from 'assets/icons/close.svg';
import ActionIcon from 'assets/icons/ios-action-icon.svg';
import './InstallPopup.scss';

const InstallPopup = (props) => {
  const [visible, setVisible] = useState(props.isVisible);
  const classes = classNames({
    iosPopup: true,
    'iosPopup--visible': visible,
  });
  const handleClose = () => {
    // console.log('closing');
    setVisible(false);
  };
  return (
    <div className={classes}>
      <section className="iosPopup__container" onClick={handleClose}>
        <img src={Close} alt="close" className="iosPopup__container__close" />

        <p><FormattedMessage id="forBestClientExp" /></p>
        <FormattedMessage id="tap" />
        <img src={ActionIcon} alt="install" className="iosPopup__container__action" />
        <FormattedMessage id="thenAddToHomeScreen" />
      </section>
    </div>
  );
};

export default InstallPopup;
